import React, { useEffect, useState } from 'react';
import {
  Box,
  makeStyles,
  Paper,
  Typography,
  Grid,
  Divider,
  ButtonBase,
  Button,
  IconButton,
} from '@material-ui/core';
import { AiOutlinePlus } from 'react-icons/ai';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import KenInputField from '../../../../../global_components/KenInputField';
import {
  getDefaultGradeRangerDatas,
  getDownGradingRulesSetup,
  postDefaultGradeRangerDatas,
  postDownGradingRulesSetup,
  deleteDowngradingRule,
} from '../../../../../Utils/apiServices';
import KenSelectWrap from '../../../../../global_components/KenSelect';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import KenLoader from '../../../../../Components/KenLoader';
const useStyles = makeStyles((theme) => ({
  box1: {
    // maxWidth: 832,
    // minWidth: 400,
    position: 'relative',
  },
  healthGrid: {
    marginTop: theme.spacing(2),
  },
  grid: {
    minWidth: '13.8vw',
  },
  detailTitle1: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.KenColors.neutral100,
    textTransform: 'uppercase',
  },
  back: {
    fontSize: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
    marginLeft: '-8px',
  },
  iconBack: {
    height: 12,
  },
  loader: {
    minHeight: '100vh',
    minWidth: '100vh',
  },
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  boxContainer: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
    paddingTop: '62px',
    paddingBottom: '30px',
  },
  boxContainer1: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
  },
  imageSection: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
  },
  innerTitle: {
    fontSize: 16,
    marginTop: '30px',
  },
  subHeaderTitle: {
    width: '100%',
  },
  ButtonStyle: {
    marginTop: '10px',
  },
}));
const selectOptionsDowngradingLevel = [
  {
    label: 'Subject',
    value: 'Subject',
  },
  {
    label: 'Term',
    value: 'Term',
  },
  {
    label: 'Degree',
    value: 'Degree',
  },
];
const selectOptionsDowngradingType = [
  {
    label: 'Mark reduction',
    value: 'Mark reduction',
  },
  {
    label: 'Grade reduction',
    value: 'Grade reduction',
  },
];

const selectOptionsDowngradeCriterion = [
  {
    label: 'Fee',
    value: 'Fee',
  },
  {
    label: 'Behaviour',
    value: 'Behaviour',
  },
  {
    label: 'Attendance',
    value: 'Attendance',
  },
];
const GradingPenalty = ({}) => {
  // const DowngradingLevel :[]
  // const [data, setData] = useState(state);
  const classes = useStyles();
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const idGenerater = () => {
    let id = Math.random().toString(36).substr(2, 9);
    return id;
  };
  const [facultyConferencesDetails, setFacultyConferencesDetails] =
    React.useState([]);

  const [relationshipAcc, setRelationshipAcc] = useState(false);
  const [deleteRow, setDeleteRow] = useState(false);
  const [loading, setLoading] = useState();

  const handleChangeRelation = (evt, i) => {
    console.log('evt.name', evt);
    setFacultyConferencesDetails(
      facultyConferencesDetails.map((e, index) => {
        console.log('eeeeee', e);
        if (i == index) {
          return {
            ...e,
            [evt.target.name]: evt.target.value,
          };
        } else {
          return { ...e, e };
        }
      })
    );
  };

  const addRow = () => {
    setFacultyConferencesDetails((prevState) => {
      console.log('prevStateprevStateprevStateprevState', prevState);
      return [
        ...prevState,
        {
          DowngradingLevel: '',
          downgradingType: '',
          reason: '',
          link: '',
          gradePenalty: '',
          isEditing: true,
        },
      ];
    });
  };

  const deleteRowHandle = (i) => {
    deleteDowngradingRule(i)
      .then((res) => {
        toast.success(`Data deleted successfully`);
        DefaultGrade();
      })
      .catch((err) => {
        console.log({ err });
      });

    // setFacultyConferencesDetails((prev) => {
    //   console.log('prevprevprevprev', prev);
    //   return prev.filter((ab) => {
    //     console.log('ababababprevprevprevprev', ab, prev, i);
    //     return ab.id !== i;
    //   });
    // });
  };

  const onEdit = (id) => {
    setFacultyConferencesDetails((prev) => {
      return prev.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            isEditing: true,
          };
        } else {
          return item;
        }
      });
    });
  };

  const onSave = (id) => {
    setFacultyConferencesDetails((prev) => {
      // console.log('prevprevprevprevidididididididid', prev, id);
      return prev.map((item) => {
        if (item.id == id) {
          console.log('prevprevprevprevidididididididid', item);

          return {
            id: item.id,
            DowngradingLevel: item.DowngradingLevel,
            downgradingType: item.downgradingType,
            reason: item.reason,
            link: item.link,
            gradePenalty: item.gradePenalty,
          };
        } else {
          return item;
        }
      });
    });
  };

  const postData = () => {
    const PanaltyData = facultyConferencesDetails.map((prev) => {
      return {
        recordId: prev.id,
        DowngradeCriterion: prev.reason,
        DowngradingLevel: prev.DowngradingLevel,
        // DowngradingType: prev.downgradingType,
        // GradePenalty: prev.gradePenalty,
        MarksPenalty: prev.link,
      };
    });

    postDownGradingRulesSetup(PanaltyData)
      .then((res) => {
        toast.success(`Data updated successfully`);
        DefaultGrade();
      })
      .catch((err) => {
        console.log({ err });
        toast.error(`${err}`);
      });
  };
  const DefaultGrade = () => {
    setLoading(true);
    getDownGradingRulesSetup().then((res) => {
      const ab = res?.data?.map((item) => {
        return {
          id: item.recordId,
          DowngradingLevel: item.DowngradingLevel,
          downgradingType: item.DowngradingType,
          reason: item.DowngradeCriterion,
          link: item.MarksPenalty,
          gradePenalty: item.GradePenalty,
          // isEditing: false,
        };
      });
      setLoading(false);

      setFacultyConferencesDetails(ab);
    });
  };

  useEffect(() => {
    DefaultGrade();
  }, []);
  return (
    <div>
      {loading && <KenLoader />}

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Box>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} />
            <>
              {' '}
              <Grid item xs={2} sm={3}>
                <Typography>
                  <b>Downgrading Level</b>
                </Typography>
              </Grid>{' '}
              {/* <Grid item xs={2} sm={2}>
                <Typography>
                  <b>Downgrading Type</b>
                </Typography>
              </Grid> */}
              <Grid item xs={2} sm={3}>
                <Typography>
                  <b>Penalty</b>
                </Typography>
              </Grid>
              <Grid item xs={1} sm={2}>
                <Typography>
                  <b>Marks Penalty</b>
                </Typography>
              </Grid>
              {/* <Grid item xs={1} sm={2}>
                <Typography>
                  <b>Grade Penalty</b>
                </Typography>
              </Grid> */}
              <Grid item xs={1} sm={1}>
                <Typography>
                  <b>Edit</b>
                </Typography>
              </Grid>
              <Grid item xs={1} sm={1}>
                <Typography>
                  <b>Delete</b>
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2}></Grid>
            </>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} />
            {facultyConferencesDetails?.map((relData, index) => {
              return (
                <>
                  <Grid item xs={2} sm={3}>
                    {/* <KenInputField
                      label="Name"
                      name="name"
                      value={relData.DowngradingLevel}
                      dropdownColor="#FFFFFF"
                      onChange={(e) => handleChangeRelation(e, index)}
                    /> */}

                    {relData.isEditing ? (
                      <KenSelectWrap
                        // disabled={readOnly}
                        // label="Downgrading Level"
                        name="DowngradingLevel"
                        options={selectOptionsDowngradingLevel}
                        value={relData.DowngradingLevel}
                        dropdownColor="#FFFFFF"
                        onChange={(e) => handleChangeRelation(e, index)}
                        // styles={CustomStyle}
                        required
                      />
                    ) : (
                      <>{relData.DowngradingLevel}</>
                    )}
                  </Grid>{' '}
                  <Grid item xs={2} sm={3}>
                    {/* <KenInputField
                      label="Name"
                      name="name"
                      value={relData.res.name}
                      dropdownColor="#FFFFFF"
                      onChange={(e) => handleChangeRelation(e, index)}
                    /> */}

                    {relData.isEditing ? (
                      <KenSelectWrap
                        // disabled={readOnly}
                        // label="Downgrading Level"
                        name="reason"
                        options={selectOptionsDowngradeCriterion}
                        value={relData.reason}
                        dropdownColor="#FFFFFF"
                        onChange={(e) => handleChangeRelation(e, index)}
                        // styles={CustomStyle}
                        required
                      />
                    ) : (
                      <>{relData.reason}</>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={2}>
                    {relData.isEditing ? (
                      <KenInputField
                        // label="Reduce By"
                        name="link"
                        value={relData.link}
                        dropdownColor="#FFFFFF"
                        onChange={(e) => handleChangeRelation(e, index)}
                        optionalLabel={false}
                      />
                    ) : (
                      <>{relData.link}</>
                    )}
                  </Grid>{' '}
                  {/* <Grid item xs={1} sm={2}>
                    {relData.isEditing ? (
                      <KenInputField
                        // label="Reduce By"
                        name="gradePenalty"
                        value={relData.gradePenalty}
                        dropdownColor="#FFFFFF"
                        onChange={(e) => handleChangeRelation(e, index)}
                        optionalLabel={false}
                      />
                    ) : (
                      <>{parseFloat(relData.gradePenalty)}</>
                    )}
                  </Grid> */}
                  <Grid item xs={1} sm={1}>
                    {/* <KenInputField
                      label="Name"
                      name="name"
                      value={relData.res.name}
                      dropdownColor="#FFFFFF"
                      onChange={(e) => handleChangeRelation(e, index)}
                    /> */}
                    {console.log('relDatarelDatarelData', relData)}
                    {relData.isEditing ? (
                      <IconButton
                        variant="contained"
                        color="error"
                        // startIcon={<DeleteForeverIcon />}
                        onClick={(e) => onSave(relData.id)}
                      >
                        {console.log('index1231', index)}
                        <DoneAllIcon />
                      </IconButton>
                    ) : (
                      <IconButton
                        variant="contained"
                        color="error"
                        // startIcon={<DeleteForeverIcon />}
                        onClick={(e) => onEdit(relData.id)}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    {/* <KenInputField
                      label="Name"
                      name="name"
                      value={relData.res.name}
                      dropdownColor="#FFFFFF"
                      onChange={(e) => handleChangeRelation(e, index)}
                    /> */}

                    <IconButton
                      variant="contained"
                      color="error"
                      // startIcon={<DeleteForeverIcon />}
                      onClick={() => deleteRowHandle(relData.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                  <Grid item sm={2}></Grid>
                  {/* <Grid item xs={12} sm={4}>
                    <KenInputField
                      label="Reduce By"
                      name="link"
                      value={relData.link}
                      dropdownColor="#FFFFFF"
                      onChange={(e) => handleChangeRelation(e, index)}
                      optionalLabel={false}
                    />
                  </Grid> */}
                </>
              );
            })}
          </Grid>
          <Grid item xs={12} sm={3} style={{ marginTop: 23 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => addRow(e)}
            >
              + Add Row
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => postData(e)}
              style={{ marginLeft: '15px' }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default GradingPenalty;
